export default __webpack_public_path__ + "static/media/doencas-fev-roxo.e40084a9.png";